import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { Flex, Spacer, TextButton } from '@zillow/constellation';

import { AddPropertyModal } from 'app/shared/components/Modal';
import { ModalSelectors } from 'app/shared/selectors';
import ModalActions from 'app/shared/actions/ModalActions';

import {
    CenteredParagraph,
    StyledButton,
    StyledYellowHR,
} from './StyledComponents';

const { makeAddPropertyModal } = ModalSelectors;
const { updateDisplayAddPropertyModal } = ModalActions;

const propTypes = {
    onLookUpListingsClick: PropTypes.func.isRequired,
};

const NoListings = ({ onLookUpListingsClick }) => {
    const dispatch = useDispatch();
    const { isOpen: isAddPropertyModalOpen } = useSelector(state => makeAddPropertyModal(state));

    const showAddPropertyModal = () => dispatch(updateDisplayAddPropertyModal({ isOpen: true }));

    return (
        <Flex display="flex" flexDirection="column" alignItems="center" justifyContent="center">
            <StyledButton
                buttonType="primary"
                onClick={onLookUpListingsClick}
            >
                Lookup listings...
            </StyledButton>
            <StyledYellowHR color="yellow300" />
            <Spacer marginBottom="xs">
                <CenteredParagraph>Do you want to manually</CenteredParagraph>
                <CenteredParagraph>create your listings on Zillow?</CenteredParagraph>
            </Spacer>
            <TextButton onClick={showAddPropertyModal}>Manually add properties</TextButton>
            {isAddPropertyModalOpen && (<AddPropertyModal isOpen={isAddPropertyModalOpen} />)}
        </Flex>
    );
};

NoListings.propTypes = propTypes;

export default NoListings;
